export var version = '3.7.11';
//# sourceMappingURL=version.js.map